import { toNumber, normalizeText } from './convertNotionalToBRL.js'

// Revenue (BRL) for DEAL rows: |fwdClient - fwd| * fxNotional, discounted
// by the BRL cost yield over the row's tenor. effectiveSpotByRow must come
// from createEffectiveSpotMap(allRows) - only used here to back out the
// foreign-currency notional for BRL-denominated rows.
export function calculateRevenueBRL(rows, effectiveSpotByRow) {
  return rows.reduce((total, row) => {
    if (normalizeText(row.status) !== 'DEAL') return total

    const notional = toNumber(row.notional)
    const fwd = toNumber(row.fwd)
    const fwdClient = toNumber(row.fwdclient)
    const days = toNumber(row.tenorDays)
    const brlCostYield = toNumber(row.yieldbrlcost)

    if (
      notional == null ||
      fwd == null ||
      fwdClient == null ||
      days == null ||
      brlCostYield == null
    ) {
      return total
    }

    let fxNotional = notional
    if (normalizeText(row.currency) === 'BRL') {
      const spot = effectiveSpotByRow.get(row)
      if (!spot) return total
      fxNotional = notional / spot
    }

    const grossRevenueBRL = Math.abs(fwdClient - fwd) * fxNotional
    const revenueBRL =
      grossRevenueBRL / Math.pow(1 + brlCostYield, days / 360)

    return total + revenueBRL
  }, 0)
}
